import './Sloader.css';







const Sloader = () => {
    return (
        <>
            <div class="🤚">
                <div className="👉"></div>
                <div className="👉"></div>
                <div className="👉"></div>
                <div className="👉"></div>
                <div className="🌴"></div>
                <div className="👍"></div>
            </div>
        </>
    )
}

export default Sloader;